/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./fitText.vue?vue&type=template&id=5a767a8a&scoped=true&"
import script from "./fitText.vue?vue&type=script&lang=js&"
export * from "./fitText.vue?vue&type=script&lang=js&"
import style0 from "./fitText.vue?vue&type=style&index=0&id=5a767a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a767a8a",
  null
  
)

export default component.exports